import date from "../../../../functions/dateFormat";
import { RiSplitCellsHorizontal } from "react-icons/ri";
import Massage from "../../../design/Massage";
import { useState } from "react";
import './TableNames.css'


export default ({ namesList, splitPassenger }) => {

    // console.log("nameslist", namesList);
    // console.log("splitPassenger props function");

    const [showSplitMessage, setShowSplitMessage] = useState(false);
    const [messageText, setMessageText] = useState("האם אתה בטוח שברצונך לפצל נוסע?");
    const [passengerId, setPassengerId] = useState();
    const [passengerName, setPassengerName] = useState();

    const [message, setMessage] = useState({ display: false, text: '' });

    const handleButtonClick = (passengerName, passengerId) => {
        // console.log('Button clicked:', passengerName, passengerId);
        // console.log("nameslist:", namesList);
        if (Object.keys(namesList).length <= 1)
            setMessage({ display: true, text: 'לא ניתן לפצל הזמנה של נוסע יחיד' })
        else {
            setMessageText(`האם אתה בטוח שברצונך לפצל את הנוסע ${passengerName} ?`)
            setShowSplitMessage(true);
            setPassengerId(passengerId);
            setPassengerName(passengerName);
        }
    };


    return (
        <>
            {
                message.display && (
                    <Massage
                        text={message.text}
                        animation={true}
                        setClose={() => setMessage({ display: false, text: '' })}
                    />
                )
            }
            {
                showSplitMessage && (
                    <div style={{
                        position: 'fixed', top: '50%', left: '50%', width: '400px', padding: '20px', transform: 'translate(-50%, -50%)', zIndex: 1000,
                    }}>

                        <Massage
                            text={messageText}
                            buttonAgree={() => { splitPassenger(passengerId, passengerName); setShowSplitMessage(false); }}
                            setClose={() => { setShowSplitMessage(false) }}
                        />
                    </div>)
            }
            <table className="table-add-names-inDocket">
                <thead>
                    <tr>
                        <td> מס'</td>
                        <td></td>
                        <td> שם </td>
                        <td> תאריך לידה </td>
                    </tr>
                </thead>

                <tbody>
                    {
                        Object.keys(namesList).map((key, keyIndex) => (
                            <tr key={keyIndex}>
                                <td key={1}> {keyIndex + 1} </td>
                                <td key="button">
                                    <div className="button-container">
                                        <button className="split-passenger-button" onClick={() => handleButtonClick(namesList[key]['name'], key)}>
                                            <RiSplitCellsHorizontal />
                                        </button>
                                        <div className="split-passenger-tooltip">פצל נוסע</div>
                                    </div>
                                </td>

                                <td key={2}> {namesList[key]['name']} </td>
                                <td key={3}> {date(namesList[key]['dob'])} </td>

                            </tr>
                        ))
                    }
                </tbody>

            </table>
        </>
    )
}